import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { doDoorKnock, doWaitImageByTime } from "../helpers/helpers";
import { V9AnnDormNightChrisAfter } from "./V9";
import { empty } from "../characters/empty";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { WaitForLoadImage } from "../../src/shell/ImageHandler/WaitForLoadImage";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v9 = images.v9;
export const V9AnnDormNightChris = async (): Promise<any> => {
    doWaitImageByTime(v9.V9MCRoomAnnWebcam_8);
    mc.think(`Sweet! Ann forgot to turn off her webcam.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_0);
    mc.think(`Look at her...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_1);
    mc.think(`Oh damn. She's not wearing any panties.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_2);
    mc.think(`I can't wait for her to get back... I miss that ass.`);

    doDoorKnock();
    mc.think(`That's not my door...`);
    mc.think(`Someone is knocking at Ann's door...? At this hour?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_3);
    ann.talk(`Huh?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_4);
    ann.talk(`Just a second!`, { method: "Shouting" });
    ImageClass.setImage(images.v9.V9AnnDormNightChris_5);
    mc.think(`I'll find out who it is in a minute...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_6);
    mc.think(`What the fuck? Chris? What's he doing there?`);
    // this condition is currently disabled
    if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "ann") {
        mc.think(`Looks like he took my offer to give him Ann way too seriously.`);
    } else {
        mc.think(`And how did he get here so fast? I just saw him a couple of hours ago.`);
        mc.think(`I'm about to find that out as well...`);
    }

    ann.talk(`Chris! What are you doing here?`);
    // if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
    //     chris.talk(`I missed you. I wanted to see you.`);
    //     ann.talk(`Hehe, I'm going to get back home real soon!`);
    //     ann.talk(`You didn't have wasted your time by coming here!`);
    //     chris.talk(`Seeing you is not a waste of time.`);

    // }
    chris.talk(`What's going on?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_7);
    chris.talk(`You've been avoiding my calls.`);
    ann.talk(`Oh...`);
    chris.talk(`Is there something wrong?`);
    ann.talk(`I really don't want to do this right now...`);
    chris.talk(`I took a flight to get here.\nYou can't just send me back without saying anything.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_6);
    ann.talk(`...`);
    ann.talk(`I- I think we should stop seeing each other...`);
    chris.talk(`Are you serious? What's wrong?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_7);
    ann.talk(`I can't really say...`);
    chris.talk(`You can't send me away without telling me what's wrong.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_8);
    await ann.setQuestion(new Question({ text: `I'm sorry, but you have to go.`, options: { think: false }, key: `v9AnnDormNightChrisKeepWatching1` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Stop watching`, key: false }));

    if (!Question.globalAnswers.v9AnnDormNightChrisKeepWatching1) {
        ImageClass.setImage(images.v9.V9MCRoomAnnWebcam_6);
        mc.think(`I've seen enough.`);
        mc.think(`I knew I could trust her.`);
        return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
    }
    if (Question.globalAnswers.V1NtrUnexpected) {
        return jump(V9AnnDormNightChris_Unexpected, "V9AnnDormNightChris_Unexpected");
    }

    doWaitImageByTime(v9.V9AnnDormNightChris_5);
    mc.think(`She really kicked him out.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_9);
    mc.think(`She looks upset...`);
    mc.think(`It will pass... She did the right thing.`);
    mc.think(`I knew I could trust her...`);
    return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
};

export const V9AnnDormNightChris_Unexpected = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9AnnDormNightChris_7);
    chris.talk(`I refuse to leave before you tell me what's going on!`);
    ann.talk(`Okay...`);
    doWaitImageByTime(v9.V9MCRoomAnnWebcam_10);
    mc.think(`She's giving him a chance to explain himself...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_10);
    ann.talk(`So...`);
    ann.talk(`I've been thinking, and I feel like it's a bad idea to see both you and ${mc.name}...`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_35);
    chris.talk(`And you chose him.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_39);
    ann.talk(`He's my boyfriend!`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_36);
    chris.talk(`And what am I?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_40);
    ann.talk(`...`);
    chris.talk(`You didn't feel this way a few days ago.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_38);
    chris.talk(`Did he tell you to stop seeing me?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_41);
    ann.talk(`No...`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_33);
    chris.talk(`He didn't have a problem with it before. What's changed?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_42);
    ann.talk(`I don't know...`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_43);
    ann.talk(`I don't want to hurt his feelings.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_37);
    chris.talk(`What about my feelings?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_44);
    ann.talk(`I don't know!`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_45);
    ann.talk(`I'm so confused. I never thought I'd have to choose.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_35);
    chris.talk(`You don't have to.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_33);
    chris.talk(`Do you really want me to leave?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_35);
    chris.talk(`Do you think I don't care about you?`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_36);
    chris.talk(`I took a flight just to see you.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_43);
    ann.talk(`I--`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_37);
    chris.talk(`If you want me to leave, just say it, and I'll go.`);
    ImageClass.setImage(images.v9.V9AnnDormNightChris_43);
    ann.talk(`I-- I don't...`);

    ImageClass.setImage(images.v9.V9AnnDormNightChris_38);
    chris.talk(`I know you don't.`);
    chris.talk(`And I also know what you'd want me to do.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_11);
    ann.talk(`I can't...`);

    return jump(V9AnnDormNightChris_Sex, "V9AnnDormNightChris_Sex");
};

export const V9AnnDormNightChris_Sex = async (): Promise<any> => {
    await mc.setQuestion(new Question({ text: `What the fuck? That escalated quickly!`, options: { think: true }, key: `v9AnnDormNightChrisKeepWatching2` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Stop watching`, key: false }));

    if (!Question.globalAnswers.v9AnnDormNightChrisKeepWatching2) {
        mc.think(`I know where this is going. I just can't keep watching this.`);

        return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
    }

    mc.think(`I can't turn the camera off now! I need to see what happens next.`);
    doWaitImageByTime(v9.Anim_V9AnnDormNightChrisBedBJ.poster);
    mc.think(`Chris grabbed Ann's head, guiding it towards his cock.`);
    ImageClass.setAnimation(images.v9.Anim_V9AnnDormNightChrisBedBJ);
    mc.think(`She started sucking it immediately.`);

    if (Question.globalAnswers.V1NtrUnexpected && !Question.globalAnswers.V8AnnDateMCOkWithChris) {
        mc.think(`So much for ending things with him...`);
    }
    doWaitImageByTime(v9.V9AnnDormNightChris_13);
    mc.think(`He then lifted her up, and they began kissing passionately.`);
    doWaitImageByTime(v9.V9MCRoomAnnWebcam_11);
    await mc.setQuestion(new Question({ text: `Do I really want to witness them having sex?`, options: { think: true }, key: `v9AnnDormNightChrisKeepWatching3` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Stop watching`, key: false }));

    if (!Question.globalAnswers.v9AnnDormNightChrisKeepWatching3) {
        mc.think(`I think that watching my girl sucking someone else's dick is enough for one day.`);
        return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
    }

    mc.think(`Despite my initial hesitation, I found myself unable to look away.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_14);
    mc.think(`Their kissing grew more intense by the moment, and then...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_15);
    mc.think(`He positioned her, entered her from behind, and they began to move in rhythm.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_16);
    mc.think(`It felt surreal, knowing what they were doing, but now I was actually seeing it.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_19);
    mc.think(`They decided to switch positions.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_20);
    mc.think(`I can only imagine what's going through her mind...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_21);
    mc.think(`Chris began rubbing his cock against her clit, preparing for what's next.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_22);
    mc.think(`I watched as Chris positioned himself behind her, ready to penetrate her again.`);
    doWaitImageByTime(v9.Anim_V9AnnChrisDormDoggy.poster);
    ImageClass.setAnimation(images.v9.Anim_V9AnnChrisDormDoggy);
    mc.think(`He pounded her from behind, faster and harder each time.`);
    if (Question.globalAnswers.V1NtrUnexpected && !Question.globalAnswers.V8AnnDateMCOkWithChris) {
        mc.think(`She was about to send him away.`);
        mc.think(`But somehow it turned into this.`);
    }
    chris.talk(`Ahhh!`);
    mc.think(`It sounds like Chris is about to cum.`);
    doWaitImageByTime(v9.V9MCRoomAnnWebcam_12);
    await mc.setQuestion(new Question({ text: `I've come this far... might as well see it through.`, options: { think: true }, key: `v9AnnDormNightChrisKeepWatching4` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Stop watching`, key: false }));

    if (!Question.globalAnswers.v9AnnDormNightChrisKeepWatching4) {
        mc.think(`I don't need to keep watching. I know how this will end.`);
        mc.think(`Fucking is one thing... But actually seeing him cum over her is something else...`);
        return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
    }
    mc.think(`I want to see everything.`);
    mc.think(`I must.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_17);
    mc.think(`Ann knelt in front of Chris, looking up at him as he positioned his penis near her face.`);
    doWaitImageByTime(v9.V9MCRoomAnnWebcam_13);
    await mc.setQuestion(new Question({ text: `This is intense...`, options: { think: true }, key: `v9AnnDormNightChrisMasturbated` })
        .option({ title: `Masturbate`, key: true })
        .option({ title: `Just watch`, key: false }));

    if (Question.globalAnswers.v9AnnDormNightChrisMasturbated) {
        doWaitImageByTime(v9.V9MCRoomAnnWebcam_14);
        mc.think(`I couldn't resist... I started masturbating while watching them.`);
    }

    doWaitImageByTime(v9.V9AnnDormNightChris_18);
    chris.talk(`Don't move.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_46);
    mc.think(`Ahh...`);
    doWaitImageByTime(v9.V9AnnDormNightChris_47);
    mc.think(`Chris ejaculated on Ann's face and glasses.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_49);
    mc.think(`From my angle, I couldn't see everything clearly.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_48);
    mc.think(`I could only imagine...`);
    mc.think(`While covered with his cum she kept looking up at him.`);
    mc.think(`He looked back admiring his recent work.`);
    doWaitImageByTime(v9.V9AnnDormNightChris_50);
    chris.talk(`Smile for the camera.`);
    mc.think(`It's like a theme for him taking pictures of girls after the act...`);
    await mc.set((properties) => {
        properties.v9HadSexWithChrisBehindMCBack = true;
    });
    endReplay(replayScenesList.V9AnnDormNightChris_Sex);

    return jump(V9AnnDormNightChrisEnd, "V9AnnDormNightChrisEnd");
};

export const V9AnnDormNightChrisEnd = async (): Promise<any> => {
    endReplay();
    if (Question.globalAnswers.v9AnnDormNightChrisMasturbated) {
        doWaitImageByTime(v9.V9MCRoomAnnWebcam_15);
        mc.think(`I can't lie... Watching them got me more excited than I should have been.`);
    } else if (Question.globalAnswers.v9AnnDormNightChrisMasturbated !== undefined) {
        doWaitImageByTime(v9.V9MCRoomAnnWebcam_6);
        mc.think(`That's it. I can't believe I just sat here and watched all of that unfold.`);
    }

    return jump(V9AnnDormNightChrisAfter, "V9AnnDormNightChrisAfter");
};
